module.exports = __webpack_public_path__ + "static/media/programa-amanha.f80aa704.png";